// Configuration for supported languages
export const languages = {
  eastAsia: [
    { code: 'zh_HK', name: '中文（香港繁體）', flag: 'hk', font: 'sans' },
    { code: 'zh_CN', name: '中文（大陆简体）', flag: 'cn', font: 'sans' },
    { code: 'ko_KR', name: '한국어', flag: 'kr', font: 'korean' },
  ],
  europe: [
    { code: 'en_US', name: 'English (US)', flag: 'us', font: 'sans' },
    { code: 'en_GB', name: 'English (UK)', flag: 'gb', font: 'sans' },
    { code: 'de_DE', name: 'Deutsch', flag: 'de', font: 'sans' },
    { code: 'es_ES', name: 'Español', flag: 'es', font: 'sans' },
    { code: 'fr_FR', name: 'Français', flag: 'fr', font: 'sans' },
    { code: 'it_IT', name: 'Italiano', flag: 'it', font: 'sans' },
  ],
  others: [
    { code: 'ar_AE', name: 'العربية', flag: 'ae', font: 'arabic', rtl: true },
    { code: 'th_TH', name: 'ภาษาไทย', flag: 'th', font: 'thai' },
  ]
};

export const allLanguages = [
  ...languages.eastAsia,
  ...languages.europe,
  ...languages.others
];

export const getFlagUrl = (countryCode) => 
  `https://cdn.jsdelivr.net/gh/lipis/flag-icons@6.11.0/flags/4x3/${countryCode}.svg`;